module.exports = __webpack_public_path__ + "static/water_nubian6-41a590dc4901d4aa7b061da2258380e4.jpg";